const ImgInput = ({ call = () => { }, width, height, aspectRatio }) => {
    return <input
        hidden
        accept="image/*"
        multiple
        type="file"
        onChange={(event) => {
            let file = event.target.files[0];
            const image = new Image();
            image.onload = () => {
                if (aspectRatio) {
                    const ratio = image.width / image.height;
                    if (Math.abs(ratio - aspectRatio) < 0.01)
                        call(file);
                    else
                        alert(`Please select an image with a ${aspectRatio === 1 ? "1:1" : aspectRatio} aspect ratio.`);
                } else {
                    if (image.width === width && image.height === height)
                        call(file);
                    else
                        alert(`Please select an image with dimensions ${width}px by ${height}px.`);
                }
            };

            image.src = URL.createObjectURL(file);
            event.target.value = null;
        }}
    />
}

export { ImgInput };